import { MessageCircle, ArrowRight, Diamond } from "lucide-react";
import { WA_LINK, BADGE_ICONS } from "./shared";

export default function Hero({ city, t }) {
  const isWebp = /\.webp$/.test(city.heroImage);
  const heroBase = city.heroImage.replace(/\.webp$/, "");
  const heroSm = `${heroBase}-sm.webp`;
  const heroMd = `${heroBase}-md.webp`;
  return (
    <section className="relative h-[640px] sm:h-[760px] md:h-[820px] overflow-hidden" data-testid="weddings-hero">
      <div className="absolute inset-0">
        <picture>
          {isWebp && <source media="(max-width: 640px)" srcSet={heroSm} type="image/webp" />}
          {isWebp && <source media="(max-width: 1024px)" srcSet={heroMd} type="image/webp" />}
          <img
            src={city.heroImage}
            alt={t.title}
            className="absolute inset-0 w-full h-full object-cover object-right sm:object-center"
            fetchPriority="high"
            decoding="async"
            loading="eager"
          />
        </picture>
        <div className="absolute inset-0 bg-gradient-to-r from-[#1A1410]/95 via-[#1A1410]/75 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#1A1410]/40 via-transparent to-[#1A1410]/30" />
      </div>
      <div className="relative z-10 max-w-[1400px] mx-auto px-5 sm:px-10 h-full flex flex-col">
        <div className="h-16 sm:h-20" />
        <div className="flex-1 flex flex-col justify-center max-w-2xl">
          <p className="text-[10px] sm:text-[11px] tracking-[0.3em] sm:tracking-[0.35em] text-[#D4B896] mb-5 sm:mb-8 font-light">{t.heroEyebrow}</p>
          <h1 className="text-white text-4xl sm:text-5xl lg:text-7xl leading-[1.05] mb-5 sm:mb-8"
              style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 400 }}
              data-testid="weddings-hero-title">
            {t.heroTitle}<br/>
            <span className="italic font-light text-[#D4B896]">{t.heroTitleAccent}</span>
          </h1>
          <p className="text-white/80 text-sm sm:text-base lg:text-lg leading-relaxed max-w-xl mb-7 sm:mb-10 font-light">{t.heroSubtitle}</p>
          <div className="flex flex-wrap gap-3 sm:gap-4">
            <a href={WA_LINK} target="_blank" rel="noopener noreferrer"
               className="group inline-flex items-center gap-2 sm:gap-3 px-7 sm:px-9 py-3.5 sm:py-4 bg-gradient-to-r from-[#D4B896] to-[#B8966F] hover:from-[#E0C8A8] hover:to-[#C9A87C] text-[#0A0807] text-[11px] sm:text-[12px] tracking-[0.22em] sm:tracking-[0.28em] font-semibold transition-all duration-500 rounded-sm shadow-[0_12px_40px_-10px_rgba(212,184,150,0.55)] hover:shadow-[0_18px_55px_-10px_rgba(212,184,150,0.75)] hover:-translate-y-0.5"
               data-testid="weddings-hero-cta-primary">
              <MessageCircle className="w-4 h-4" />
              <span>{t.ctaPrimary}</span>
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
            </a>
            <a href="#gallery"
               className="inline-flex items-center px-6 sm:px-8 py-3.5 sm:py-4 border border-white/60 text-white text-[11px] sm:text-[12px] tracking-[0.2em] sm:tracking-[0.25em] font-medium hover:bg-white/10 hover:border-white transition rounded-sm"
               data-testid="weddings-hero-cta-secondary">{t.ctaSecondary}</a>
          </div>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6 md:gap-10 pb-8 sm:pb-12">
          {t.badges.map((b, i) => {
            const Icon = BADGE_ICONS[i] || Diamond;
            return (
              <div key={i} className="flex items-center gap-2.5 sm:gap-3 text-white">
                <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-full border border-white/30 flex items-center justify-center shrink-0">
                  <Icon className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-[#D4B896]" />
                </div>
                <div>
                  <div className="text-[10px] sm:text-[11px] tracking-[0.18em] sm:tracking-[0.2em] font-medium leading-tight">{b.title}</div>
                  <div className="text-[11px] sm:text-[12px] text-white/70 font-light leading-tight">{b.subtitle}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
